"use client"

import { ShippingMethods } from "@/app/(site)/[locale]/checkout/CheckoutContent/components/ShippingMethods"
import { type CheckoutStep } from "@/app/(site)/contexts/ecommerce/types"
import { type CheckoutPageSettingsContent } from "@/types"

interface DeliveryProps {
    setStep: (step: CheckoutStep) => void
    langCode: string
    paymentPrivacyNotice?: CheckoutPageSettingsContent["paymentPrivacyNotice"]
}

export default function DeliveryNew({
    setStep,
    langCode,
    paymentPrivacyNotice
}: DeliveryProps) {
    return (
        <div className="flex flex-col gap-32 pb-32">
            <ShippingMethods
                langCode={langCode}
                setStep={setStep}
                paymentPrivacyNotice={paymentPrivacyNotice}
            />
        </div>
    )
}
